import { React, useState, useEffect } from "react";

import styles from "./Test.module.css"

//#region 发送api请求userinfo示例
/*
import http from "./utils/http"

export default (props) => {
    const [dftOutput, SetDftOutput] = useState('这是默认内容')

    async function onBtnClick() {
        try{
            const res = await http.get('/userinfo')
            const { data } = res;
            if (data.success) {
                console.log("data = " + data.user)
                SetDftOutput(data.user)
            } 
        }catch(err){
            console.error('请求异常:',err)
            alert('登陆失败')
        }
    }
    return (<div>
        这里是Test.js
        <div text={dftOutput}>
            {dftOutput}
        </div>
        <Button onClick={onBtnClick}>默认按钮</Button>
    </div>)
}
*/
//#endregion

//#region 虚拟列表antd-list + react-virtualized 失败
/* 
import { List, Image } from 'antd-mobile'
const rowCount = 1000

const item = {
   avatar:
       'https://images.unsplash.com/photo-1548532928-b34e3be62fc6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ',
   name: 'Novalee Spicer',
   description: 'Deserunt dolor ea eaque eos',
}

const data = Array(rowCount).fill(item)
 
 
export default () => {
   function rowRenderer({ index, key, style }) {
       const item = data[index]
       return (
           <List.Item
               key={key}
               style={style}
               prefix={
                   <Image
                       src={item.avatar}
                       style={{ borderRadius: 20 }}
                       fit='cover'
                       width={40}
                       height={40}
                   />
               }
               description={item.description}
           >
               {item.name} {index}
           </List.Item>
       )
   }
   
   return (
       <List style={{ height: "100%" }} header='结合 react-virtualized 实现长列表'>
           <AutoSizer>
               {({ width, height }) => (
                   <VirtualizedList
                       rowCount={rowCount}
                       rowRenderer={rowRenderer}
                       width={width}
                       height={height}
                       rowHeight={60}
                       overscanRowCount={10}
                   />
               )}
           </AutoSizer>
       </List>
   ) 
}; */
//#endregion

//#region  虚拟列表react-window 失败
/*
import { FixedSizeList as VirtualList } from 'react-window'

const data = Array.from({ length: 1000 }, (_, i) => `Item ${i + 1}`);
const VirtualizedList = () => {
    // 根据视口高度动态计算列表高度 (60vh)
    const [listHeight, setListHeight] = useState(window.innerHeight * 0.6);
  
    useEffect(() => {
      // 窗口尺寸变化时更新高度
      const handleResize = () => setListHeight(window.innerHeight * 0.6);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    // 虚拟列表的行渲染器
    const Row = ({ index, style }) => (
      // 关键：将 react-window 提供的 style 传给 List.Item
      <List.Item style={style}>
        {data[index]}
      </List.Item>
    );
  
    return (
      <div style={{ width: '80vw', height: '60vh' }}>
        <VirtualList
          height={listHeight}          // 容器高度 (px)
          itemCount={data.length}      // 列表总项数
          itemSize={50}                // 每项固定高度 (px)，根据需要调整
          width={'100%'}               // 宽度占满容器
        >
          {Row}
        </VirtualList>
      </div>
    );
  };
  export default VirtualizedList;
  */
//#endregion

//#region 虚拟列表 antd + react-window 失败
/*
import { FixedSizeList as VirtualList } from 'react-window'
import { Image, List } from 'antd-mobile'

const rowCount = 1000

const item = {
  avatar:
    'https://images.unsplash.com/photo-1548532928-b34e3be62fc6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ',
  name: 'Novalee Spicer',
  description: 'Deserunt dolor ea eaque eos',
}

const data = Array(rowCount).fill(item)


// const data = Array.from({ length: 1000 }, (_, i) => `Item ${i + 1}`);
const AntVirtualList = () => {
  // 根据视口高度动态计算列表高度 (60vh)
  const [listHeight, setListHeight] = useState(window.innerHeight * 0.6);

  useEffect(() => {
    // 窗口尺寸变化时更新高度
    const handleResize = () => setListHeight(window.innerHeight * 0.6);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 虚拟列表的行渲染器
  const Row = ({ index, style }) => (
    // 关键：将 react-window 提供的 style 传给 List.Item
    <List.Item style={style}>
      {data[index]}
    </List.Item>
  );
  function rowRenderer({ index, key, style }) {
    const item = data[index]
    return (
      <List.Item
        key={key}
        style={style}
        prefix={
          <Image
            src={item.avatar}
            style={{ borderRadius: 20 }}
            fit='cover'
            width={40}
            height={40}
          />
        }
        description={item.description}
      >
        {item.name} {index}
      </List.Item>
    )
  }


  return (
    <div style={{ width: '80vw', height: '60vh' }}>
      <List header = '结合 react-virtualized 实现长列表' >
        <VirtualList
          height={listHeight}          // 容器高度 (px)
          itemCount={data.length}      // 列表总项数
          itemSize={50}                // 每项固定高度 (px)，根据需要调整
          width={'100%'}               // 宽度占满容器
        >
          {rowRenderer}
        </VirtualList>
      </List >
    </div >
  );
};

export default AntVirtualList;
*/
//#endregion

//#region 新-虚拟列表antd-list + react-virtualized 成功!
import { List, Image } from 'antd-mobile'
import { List as VirtualizedList, AutoSizer } from 'react-virtualized'
const rowCount = 1000

const item = {
  avatar:
    'https://images.unsplash.com/photo-1548532928-b34e3be62fc6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ',
  name: 'Novalee Spicer',
  description: 'Deserunt dolor ea eaque eos',
}

const data = Array(rowCount).fill(item)


export default () => {

  // 根据视口高度动态计算列表高度 (60vh)
  const [listHeight, setListHeight] = useState(window.innerHeight * 0.6 - 20);

  useEffect(() => {
    // 窗口尺寸变化时更新高度
    const handleResize = () => setListHeight(window.innerHeight * 0.6 - 20);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function rowRenderer({ index, key, style }) {
    const item = data[index]
    return (
      <List.Item
        key={key}
        style={style}
        prefix={
          <Image
            src={item.avatar}
            style={{ borderRadius: 20 }}
            fit='cover'
            width={40}
            height={40}
          />
        }
        description={item.description}
      >
        {item.name} {index}
      </List.Item>
    )
  }

  return (
      <List mode="card" header='结合 react-virtualized 实现长列表'>
        <AutoSizer disableHeight>
          {({ width }) => (
            <VirtualizedList
              rowCount={rowCount}
              rowRenderer={rowRenderer}
              width={width}
              height={listHeight}
              rowHeight={60}
              overscanRowCount={10}
            />
          )}
        </AutoSizer>
      </List>
)
};
//#endregion






